import { render, staticRenderFns } from "./NavBackBtn.vue?vue&type=template&id=33d9ff76&scoped=true&"
import script from "./NavBackBtn.vue?vue&type=script&lang=js&"
export * from "./NavBackBtn.vue?vue&type=script&lang=js&"
import style0 from "./NavBackBtn.vue?vue&type=style&index=0&id=33d9ff76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9ff76",
  null
  
)

export default component.exports